import { Box, Typography } from "@mui/material";
import styles from "./CustomStatusPill.module.scss";

interface CustomStatusPillProps {
  statusCode: string;
  status: string;
}

const CustomStatusPill = ({ statusCode, status }: CustomStatusPillProps) => {
  const className = styles[statusCode.toLowerCase()] || styles.default;

  return (
    <Box className={`${styles.pill} ${className}`} data-testid="status-pill">
      <Typography variant="bodySmall" color={"common.black"}>
        {status}
      </Typography>
    </Box>
  );
};

export default CustomStatusPill;
